import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import slideOneSvg from 'assets/autoSlider/slideOne.svg';
import slideOneMobileSvg from 'assets/autoSlider/slideOneMobile.svg';
import slideThreeSvg from 'assets/autoSlider/slideThree.svg';
import slideTwoSvg from 'assets/autoSlider/slideTwo.svg';

export const useSlides = () => {
  const { t } = useTranslation('slides');
  const slides = useMemo(
    () => [
      {
        id: 1,
        title: t('title.slideOne'),
        desktopContentSource: slideOneSvg,
        mobileContentSource: slideOneMobileSvg,
        desktopDescription: t('desktopDescription.slideOne'),
        mobileDescription: t('mobileDescription.slideOne'),
      },
      {
        id: 2,
        title: t('title.slideTwo'),
        desktopContentSource: slideTwoSvg,
        mobileContentSource: slideTwoSvg,
        desktopDescription: t('desktopDescription.slideTwo'),
        mobileDescription: t('mobileDescription.slideTwo'),
      },
      {
        id: 3,
        title: t('title.slideThree'),
        desktopContentSource: slideThreeSvg,
        mobileContentSource: slideThreeSvg,
        desktopDescription: t('desktopDescription.slideThree'),
        mobileDescription: t('mobileDescription.slideThree'),
      },
    ],
    [],
  );

  return slides;
};
